module.exports = __webpack_public_path__ + "static/img/DSC_1563_03.a2174820.png";